import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SalesPersonService } from 'src/app/services/crew-services/sales-person.service';
import { GeneralService } from 'src/app/services/general.service';
import { TargetService } from 'src/app/services/target.service';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';
import { of } from 'rxjs';
import * as $ from 'jquery';

@Component({
  selector: 'app-assign-commission-profile',
  templateUrl: './assign-commission-profile.component.html',
  styleUrls: ['./assign-commission-profile.component.css']
})
export class AssignCommissionProfileComponent implements OnInit, AfterViewInit {

  @Input() commission: any;
  @Input() profiles: any;
  @Input() fromSalesProfile: boolean = false;
  @Input() salesperson: any;
  @ViewChild('closeButton') closeButton!: ElementRef;
  @ViewChild("targetSelect") targetSelect!: ElementRef;
  @ViewChild("commission") commissionSelect!: ElementRef;
  assignPeriodList: any;
  assignedTargetsV2: any[] = [];
  assignedCommissions: Array<{}> = [];
  loadingView = false;
  loading: boolean = false;
  salesPersonsList: any[] = [];
  targetList: any[] = [];
  target_limit: any;
  target: any;
  periodList: any[] = [];
  targets!: Observable<any>;
  commission_period_value: Number = 0;
  dataTable = {
    dataChangedObs: new BehaviorSubject<any>(null),
    heads: [
      { title: "Commission", key: "commission", template: (row: any) => `${row['commission']}` },
      { title: "Target", key: "target", template: (row: any) => `${row['target']}` },
      { title: "Period", key: "period", template: (row: any) => `${row['period']}` },
      { title: "Type", key: "type", template: (row: any) => `${row['type']}` },
      { title: "Threshold", key: "threshold", template: (row: any) => `${row['threshold']}` },
      { title: "Accelerator", key: "accelerator_threshold", template: (row: any) => `${row['accelerator_threshold']}` },
      { title: "Action", key: "action" }
    ],
    options: {
      bulkActions: [],
      singleActions: [
        {
          title: "Remove",
        }
      ]
    }
  };
  assignCommissionForm!: FormGroup;
  commission_accelerator: any;
  selectedTarget: any;
  selectedSubPeriod: any;
  commissionList: any;
  commissions!: Observable<any[]>;
  showCommissionProfile: boolean = false;
  constructor(
    private fb: FormBuilder,
    private salepersonSrv: SalesPersonService,
    private targetService: TargetService,
    public generalService: GeneralService
  ) { }

  ngOnInit() {
    $.getScript("/assets/js/datatableScript.js");
    this.createAssignedCommissionForm();
    if (this.fromSalesProfile && this.salesperson) {
      this.getCommissions();
      this.assignCommissionForm.patchValue({
        salespersonID: this.salesperson.id
      });
      this.getAssignedCommissions();
    } else {
      this.getSalespersons();
      this.getAcceleratorThreshold()
    }


  }

  ngAfterViewInit() {
    //@ts-ignore
    document.querySelector("[data-target='#assignCommissionModal'").addEventListener("click", () => {
      this.showCommissionProfile = true;
    });
  }

  closeModal() {
    this.generalService.modal.closeActive()
  }



  dataFeedBackObsListener2 = (data: any) => {
    if (data.action === 'Remove') {
      this.reverseAssignCommission(data.data.id)
    }
  }

  createAssignedCommissionForm() {
    this.assignCommissionForm = this.fb.group({
      salespersonID: ["", Validators.required],
      targetID: ["", Validators.required],
      subPeriodID: ["", Validators.required],
      periodId: ["", Validators.required],
      threshold: ["",
        [
          Validators.required,
          CustomValidators.number
        ]
      ],
      accelerator_threshold: ["", CustomValidators.number],
      stage: ["", Validators.required]
    });
  }

  private getAssignedCommissions() {
    this.loadingView = true;
    const getAssignedCommissions$ = this.targetService.getAssignedCommissions(this.assignCommissionForm.value.salespersonID);
    if (!getAssignedCommissions$) return;
    getAssignedCommissions$.subscribe((res: any) => {
      this.loadingView = false;
      if (res.status === 200) this.assignedCommissions = res.response;
      this.dataTable.dataChangedObs.next(true);
    });
  }

  recreateForm() {
    const selectedSalesPerson = this.assignCommissionForm.value.salespersonID;
    this.createAssignedCommissionForm();
    this.assignCommissionForm.patchValue({
      salespersonID: selectedSalesPerson
    });
    this.selectedTarget = null;
    this.selectedSubPeriod = null;
    this.commission_period_value = 0;

  }


  getAssignedTargetsV2() {
    this.recreateForm();
    const getAssignedTargetsV2$ = this.targetService.getAssignedTargetsV2(this.assignCommissionForm.value.salespersonID);
    if (!getAssignedTargetsV2$) return;
    getAssignedTargetsV2$.subscribe((res: any) => {
      if (res.status !== 200) return
      this.assignedTargetsV2 = res.response;
      this.assignedTargetsV2 = this.assignedTargetsV2.filter((e: any) => {
        const target_type = this.targetService.getTargetType(e.type);
        if (target_type.value != this.commission.type) {
          return false
        };
        if (!target_type.commissionEnabled) {
          return false
        };
        return true;
      }).map((e: any) => {
        return {
          ...e,
          key: e.id + '_' + e.stage,
          stage: e.stage,
          description: e.description || `${e.target}  (${this.targetService.getTargetType(e.type)['name']} -> ${this.targetService.getTargetStage(e.stage)['name']})`,

        };
      });
      this.targets = of([{ id: '', stage: '', description: 'Select Target' }, ...this.assignedTargetsV2]);
      this.getAssignedCommissions();

    });
  }

  addStageToForm(selectedTargetKey: string) {
    const target_obj = this.assignedTargetsV2.find(e => {
      return e.key === selectedTargetKey;
    });
    this.selectedTarget = target_obj;
    this.assignCommissionForm.patchValue({
      stage: this.selectedTarget.stage,
      targetID: this.selectedTarget.id,
      periodId: this.selectedTarget.period

    });
  }


  getPeriods2(selectedTargetKey: string) {
    if (!selectedTargetKey) return;
    //save target stage
    this.addStageToForm(selectedTargetKey);
    const target = this.selectedTarget.id;
    const getAssignedPeriods$ = this.targetService.getAssignedPeriods(this.assignCommissionForm.value.salespersonID, target, this.selectedTarget.stage);
    if (!getAssignedPeriods$) return;
    getAssignedPeriods$.subscribe((res: any) => {
      if (res.status !== 200) return
      this.periodList = res.response;
      this.assignPeriodList = this.periodList.map((e: any) => {
        return { id: e.id, description: e.name };
      });
      this.getTargetLimit();

    });
  }


  assignCommission() {
    const commissionDetails = this.assignCommissionForm.value;
    $("#assignCommissionModal .close").click();
    this.generalService.sweetAlertFileCreations("Commission").then(res => {
      if (res.value) {
        let obj: any = {
          userId: commissionDetails.salespersonID,
          targetId: commissionDetails.targetID,
          stage: commissionDetails.stage,
          commissionId: this.commission.id,
          sub_periodId: commissionDetails.subPeriodID,
          type: this.commission.type,
          threshold: Number(commissionDetails.threshold),
          periodId: commissionDetails.periodId,
          accelerator_threshold: Number(commissionDetails.accelerator_threshold),
          target_value: this.commission_period_value
        };
        if (
          !obj.targetId ||
          !obj.commissionId ||
          !obj.sub_periodId ||
          !obj.threshold
        )
          return this.generalService.notification(
            "Kindly fill all required field(s)",
            "",
            "warning"
          );
        if (obj.threshold < 1 || obj.threshold > 100) {
          return this.generalService.notification(
            `Commission threshold rate (${obj.threshold}%)
            must be at least 1% and at most 100%. (Total allocated target is valued at ${this.commission_period_value})`,
            "",
            "warning"
          );
        }
        if (
          obj.accelerator_threshold &&
          obj.accelerator_threshold <= obj.threshold
        ) {
          return this.generalService.notification(
            `Accelerator threshold (${obj.accelerator_threshold}%)
            must be greater than ${obj.threshold}%.`,
            "",
            "warning"
          );
        }

        if (obj["type"] !== this.selectedTarget["type"])
          return this.generalService.notification(
            "Commission and Target must be of the same type",
            "",
            "warning"
          );
        this.loading = true;
        const addAssignedCommission$ = this.targetService.addAssignedCommission(obj);
        if (!addAssignedCommission$) return;
        addAssignedCommission$
          .subscribe((response: any) => {
            this.loading = false;
            if (response.status === 200) {
              this.generalService.notification(
                "Commission assigned successfully!",
                "",
                "success"
              );
              this.assignCommissionForm.reset();
              this.targetSelect.nativeElement.value = "";
              this.commissionSelect.nativeElement.value = "";
              this.assignedCommissions = [];
              this.dataTable.dataChangedObs.next(true);
              if (this.fromSalesProfile) {
                this.closeModal()
              }
            } else {
              this.generalService.notification(response.error, "", "error");
            }
          },
            error => {
              this.loading = false;
              this.generalService.sweetAlertError(this.generalService.getErrMsg(error));
            }
          );
      }
    });
  }


  /**
   * Reverse Assign Commission
   * @param id 
   */
  reverseAssignCommission(id: any) {
    $("#assignCommissionModal .close").click();
    this.generalService.sweetAlertFileDeletions("Commission").then(result => {
      if (result.value) {
        const deleteAssignedCommission$ = this.targetService.deleteAssignedCommission(id, this.assignCommissionForm.value.salespersonID
        );
        if (!deleteAssignedCommission$) return;
        deleteAssignedCommission$.subscribe(
          result2 => {
            if (result2) {
              Swal.fire(
                "Deleted!",
                "Your file has been deleted.",
                "success"
              ).then(res => {
                this.getAssignedCommissions();
              });
            }
          },
          error => {
            this.generalService.sweetAlertError(this.generalService.getErrMsg(error));
          }
        );
      }
    });
  }

  private getTargetLimit() {
    const getTargetLimit$ = this.targetService.getTargetLimit(this.target);
    if (!getTargetLimit$) return;
    getTargetLimit$.subscribe((res: any) => {
      if (res.status === 200)
        this.target_limit = res.response.unallocated;
    });
  }

  private async getSalespersons() {
    try {
      const type = 5;
      const salesPersonList = await this.salepersonSrv
        .fetchSalesperson(type)
        .toPromise();
      this.salesPersonsList = salesPersonList.filter(
        ({ userRel }: any) => userRel.salesPerson
      );
    } catch (error) { }
  }
  getCommissionPeriodValue() {
    const commission_period = this.assignCommissionForm.value.subPeriodID;
    this.commission_period_value = Number(
      this.periodList.filter(e => {
        return e["id"] === Number(commission_period);
      })[0]["value"]
    );

  }

  getAcceleratorThreshold() {
    const commission_id = this.commission;
    if (commission_id) {
      this.commission_accelerator = this.profiles.filter((e: any) => {
        return e["id"] === Number(commission_id.id);
      })[0];
    }
  }




  /**
 * Get Commissions
 */
  private getCommissions() {
    const getCommissions$ = this.targetService.getCommissionProfiles();
    if (!getCommissions$) return;
    getCommissions$.subscribe((res: any) => {
      if (res.status !== 200) return;
      this.profiles = res.response.map((e: any) => {
        return {
          ...e,
          key: e.id,
          description: `${e.title} (${e.type})`
        };
      });
      this.commissions = of([{ id: '', description: 'Select Commission' }, ...this.profiles]);
    });
  }

  handleCommissionChange(commissionId: any) {
    this.commission = this.profiles.find((e: any) => {
      return e["id"] === Number(commissionId);
    });
    this.getAcceleratorThreshold()
    this.getAssignedTargetsV2();


  }


}
